module.exports = __webpack_public_path__ + "static/media/image-default-completed.e896b5ce.png";